import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { PartnerAnalysisGroup1 } from 'src/app/assabil-kernel/models/entities/control-tables/partner-analysis-group1';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PartnerAnalysisGroup1Request } from 'src/app/assabil-kernel/models/dtos/control-tables/partner-analysis-group1-request';


@Component({
  selector: 'app-partner-analysis-group1-list',
  templateUrl: './partner-analysis-group1-list.component.html',
  styleUrls: ['./partner-analysis-group1-list.component.scss']
})
export class PartnerAnalysisGroup1ListComponent extends BasePage2<PartnerAnalysisGroup1> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  partnersAnalysisGroups: PartnerAnalysisGroup1[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'partnerAnalysisGroup1';
  }



  listFields = [
      { prop: 'partnerAnalysisGroup1Code', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' }
  ]

  getRows(): PartnerAnalysisGroup1[] {
      return this.partnersAnalysisGroups;
  }


//----------------------------------------------------------------------
saveRow(partnerAnalysisGroup1: PartnerAnalysisGroup1): Promise<PartnerAnalysisGroup1> {
  let request  : PartnerAnalysisGroup1Request = new PartnerAnalysisGroup1Request(this.controlService.getUserInfo());
  request.partnerAnalysisGroup1 = partnerAnalysisGroup1;
    return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------


  //----------------------------------------------------------------------
  new(){
    let entity : PartnerAnalysisGroup1 = new PartnerAnalysisGroup1();
    entity.inserted = true;
    entity.edit = true;
    this.partnersAnalysisGroups.push(entity);
    this.partnersAnalysisGroups = [...this.partnersAnalysisGroups];
    }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.partnersAnalysisGroups = result;
    }).catch(error => {
        this.showError(error);
    })
  }
//----------------------------------------------------------------------

}
